module.exports = __webpack_public_path__ + "static/media/shelly-smiling-smaller.b2fe484c.png";